<template>
  <v-card class="card-shadow mt-4 border-radius-xl">
    <v-card-title class="pb-0 d-flex align-center px-4 pt-4">
      <h6 class="mb-0 text-h6 text-typo font-weight-bold">公司基本資料</h6>
      <v-spacer></v-spacer>
      <template v-if="!isCreateMode">
        <template v-if="!edit">
          <v-btn icon @click="startEdit" :ripple="false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon class="mr-2" @click="cancelEdit" :ripple="false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn icon :loading="saving" @click="submit" :ripple="false">
            <v-icon color="red">mdi-content-save</v-icon>
          </v-btn>
        </template>
      </template>
    </v-card-title>
    <v-card-text class="px-4 pb-4">
      <v-row>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >公司名稱</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.company_name || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.company_name"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >統一編號</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.taxid || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.taxid"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >資本額</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.capital_str || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.capital_str"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >員工人數</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.employee_num || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model.number="form.employee_num"
                type="number"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >網站</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.website || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.website"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >API</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.api || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.api"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0" v-if="!isCreateMode">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >建立時間</v-list-item-subtitle
              >
              <v-list-item-title class="text-typo">{{
                formatDate(companyData.create_time) || "暫無資料"
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="!isCreateMode">
          <v-list-item class="px-2">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >顯示薪資結算功能</v-list-item-subtitle
              >
              <template v-if="!edit">
                <v-list-item-title class="text-typo">
                  {{ companyData.enable_salary_preview ? "是" : "否" }}
                </v-list-item-title>
              </template>
              <template v-else>
                <template v-if="canEditSalaryPreview">
                  <v-switch
                    v-model="form.enable_salary_preview"
                    inset
                    hide-details
                    color="blue"
                    class="mt-0 px-2"
                    :label="
                      form.enable_salary_preview
                        ? '啟用薪資結算'
                        : '停用薪資結算'
                    "
                  ></v-switch>
                </template>
                <template v-else>
                  <v-list-item-title class="text-typo">
                    {{ form.enable_salary_preview ? "是" : "否" }}
                  </v-list-item-title>
                </template>
              </template>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12">
          <v-list-item class="px-0" v-if="isCreateMode">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body mb-2">
                預設班表型態
              </v-list-item-subtitle>
              <v-radio-group
                v-model="form.schedule_template_type"
                row
                hide-details
                class="mt-1"
              >
                <v-radio
                  v-for="option in scheduleTemplateOptions"
                  :key="option.value"
                  :value="option.value"
                  color="blue"
                  class="mr-6"
                >
                  <template #label>
                    <div class="d-flex flex-column">
                      <span class="font-weight-medium">{{ option.label }}</span>
                      <span class="text-caption text--secondary">
                        {{ option.description }}
                      </span>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { SCHEDULE_TYPE } from "@/constants";
import { mapGetters } from "vuex";

export default {
  name: "CompanyBasicInfoWidget",
  props: {
    companyData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isCreateMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("user", ["rootRole"]),
    canEditSalaryPreview() {
      return this.rootRole;
    },
  },
  data() {
    return {
      edit: this.isCreateMode,
      saving: false,
      scheduleTemplateOptions: [
        {
          value: "fixed",
          label: "固定週休二日",
          description: "固定班表，週休二日",
          fixed: true,
          scheduleType: SCHEDULE_TYPE.GENERAL,
        },
        {
          value: "biweekly_flex",
          label: "雙週變形工時",
          description: "雙週變形工時班表",
          fixed: false,
          scheduleType: SCHEDULE_TYPE.BIWEEKLY_FLEX,
        },
        {
          value: "fourweek_flex",
          label: "四週變形工時",
          description: "四週變形工時班表",
          fixed: false,
          scheduleType: SCHEDULE_TYPE.FOURWEEK_FLEX,
        },
      ],
      form: {
        company_name: "",
        taxid: "",
        capital_str: "",
        employee_num: null,
        website: "",
        fixed_working_days: true,
        schedule_type: SCHEDULE_TYPE.GENERAL,
        schedule_template_type: "fixed",
        api: null,
        enable_salary_preview: false,
      },
    };
  },
  watch: {
    companyData: {
      handler() {
        this.resetForm();
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        // In create mode, emit changes immediately
        if (this.isCreateMode) {
          this.$emit("save", newVal, () => {});
        }
      },
      deep: true,
    },
    "form.schedule_template_type"(newValue) {
      if (this.isCreateMode) {
        this.applyScheduleTemplate(newValue);
      }
    },
  },
  methods: {
    resetForm() {
      const templateType = this.resolveScheduleTemplateType();
      const templateOption =
        this.scheduleTemplateOptions.find(
          (opt) => opt.value === templateType
        ) || this.scheduleTemplateOptions[0];
      this.form = {
        company_name: this.companyData.company_name || "",
        taxid: this.companyData.taxid || "",
        capital_str: this.companyData.capital_str || "",
        employee_num: this.companyData.employee_num || null,
        website: this.companyData.website || "",
        fixed_working_days:
          typeof this.companyData.fixed_working_days === "boolean"
            ? this.companyData.fixed_working_days
            : templateOption.fixed,
        schedule_type:
          this.companyData.schedule_type || templateOption.scheduleType,
        schedule_template_type: templateType,
        api: this.companyData.api || null,
        enable_salary_preview: this.companyData.enable_salary_preview === true,
      };
      if (this.isCreateMode) {
        this.applyScheduleTemplate(templateType);
      }
    },
    startEdit() {
      this.edit = true;
      this.resetForm();
    },
    cancelEdit() {
      this.edit = false;
      this.resetForm();
    },
    submit() {
      if (this.saving) return;
      this.saving = true;
      const payload = {
        company_name: this.form.company_name,
        taxid: this.form.taxid,
        capital_str: this.form.capital_str,
        employee_num: this.form.employee_num,
        website: this.form.website,
        fixed_working_days: this.form.fixed_working_days,
        schedule_type: this.form.schedule_type,
        api: this.form.api,
        enable_salary_preview: this.form.enable_salary_preview,
      };
      this.$emit("save", payload, (ok) => {
        this.saving = false;
        if (ok) this.edit = false;
      });
    },
    applyScheduleTemplate(templateValue) {
      const option =
        this.scheduleTemplateOptions.find(
          (opt) => opt.value === templateValue
        ) || this.scheduleTemplateOptions[0];
      this.form.fixed_working_days = option.fixed;
      this.form.schedule_type = option.scheduleType;
    },
    resolveScheduleTemplateType() {
      if (this.companyData.schedule_type === SCHEDULE_TYPE.BIWEEKLY_FLEX) {
        return "biweekly_flex";
      }
      if (this.companyData.schedule_type === SCHEDULE_TYPE.FOURWEEK_FLEX) {
        return "fourweek_flex";
      }
      if (this.companyData.fixed_working_days === false) {
        return "biweekly_flex";
      }
      return "fixed";
    },
    formatDate(dateString) {
      if (!dateString) return "暫無資料";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "無效日期";
      return date.toLocaleDateString("zh-TW", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>
